class ImagePopupController {
    /**
     * @param {Object} $modal
     */
    constructor($mdDialog) {
        this.$mdDialog = $mdDialog;
    }

    $onInit() {
    }

    isSourceUrl() {
        return this.imgSrc && this.imgSrc.includes &&
            (this.imgSrc.includes('api/uploads') || this.imgSrc.includes('.jpg'));
    }

    openPopup() {
        this.$mdDialog.show({
            clickOutsideToClose: true,
            templateUrl: 'imagePopup.tmpl.html',
            parent: angular.element(document.body),
            multiple: false,
            locals: {
                imgSrc: this.imgSrc,
                isUrl: this.isSourceUrl()
            },
            controller: function DialogController($scope, $mdDialog, imgSrc, isUrl) {
                $scope.imgSrc = imgSrc;
                $scope.isUrl = isUrl;

                $scope.cancelDialog = function() {
                    $mdDialog.cancel();
                };
            }
        }).then(function() {}, function() {});
    }
}

ImagePopupController.$inject = ['$mdDialog'];

export default ImagePopupController;



// WEBPACK FOOTER //
// ./src/app/components/imagePopup/imagePopupController.js